// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J7e_z","newExpiryDate":"styles_newExpiryDate__3jpoA","footer":"styles_footer__17VGt"};